import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { DialogActions } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { IconEdit } from '../../assets/icons';
import { getLocaleByLanguage } from '../../utils/helpers';
import './index.scss';

type CalendarProps = {
  label: string;
  date: Date;
  onChange: (date: Date) => void;
  hidden?: boolean;
  covered?: boolean;
  minDate?: Date;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};

const CustomActionBar: React.FC = ({ onAccept, onCancel }: any) => {
  const { t } = useTranslation('common');

  return (
    <DialogActions className="actions">
      <button onClick={onCancel}>{t('buttons.cancel')}</button>
      <button onClick={onAccept}>OK</button>
    </DialogActions>
  );
};

const Calendar: React.FC<CalendarProps> = ({
  date,
  label,
  onChange,
  hidden = false,
  covered = false,
  minDate,
  open,
  onOpen,
  onClose,
}) => {
  const [dateInternal, setDateInternal] = useState<Date>(new Date());
  const [year] = useState<number>(new Date().getFullYear());
  const adapterLocale = getLocaleByLanguage();

  useEffect(() => {
    setDateInternal(new Date(date));
  }, [date]);

  const handleDateChange = (newDate: Date | null) => {
    if (newDate) {
      setDateInternal(new Date(newDate));
    }
  };

  const handleAccept = () => {
    onChange(new Date(dateInternal));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
      <MobileDatePicker
        className={classNames('custom-calendar', {
          'custom-calendar--covered': covered,
          'custom-calendar--hidden': hidden,
        })}
        localeText={{ toolbarTitle: `${year}` }}
        slots={{
          actionBar: CustomActionBar,
        }}
        format="dd.MM.yyyy"
        value={date}
        onChange={handleDateChange}
        onAccept={handleAccept}
        disablePast
        label={label}
        slotProps={{
          textField: {
            InputProps: {
              endAdornment: <IconEdit />,
              className: 'form-control',
            },
          },
          dialog: {
            className: 'calendar-dialog-root',
          },
        }}
        {...(typeof open !== 'undefined' ? { open } : {})}
        {...(onOpen ? { onOpen } : {})}
        {...(onClose ? { onClose } : {})}
        {...(minDate ? { minDate } : {})}
      />
    </LocalizationProvider>
  );
};

export default Calendar;
